import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: '3px solid rgba(149, 149, 149, 0.1)',
    padding: '30px 15px',
  },
  title: {
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: '400',
    textTransform: 'uppercase',
    color: '#F97F11',
  },
  info: {
    marginTop: '15px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  field: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    marginLeft: '5px',
    fontSize: '0.775rem',
    fontWeight: '500',
  },
});

export default useStyles;
